<div class="mat-typography deployment-settings">
    <ui-nuget-deployment-settings [deploymentSettings]="settings.deployment.packages"
                                  [nugetType]="NugetType.Packages">
    </ui-nuget-deployment-settings>
    <ui-nuget-deployment-settings [deploymentSettings]="settings.deployment.libraries"
                                  [nugetType]="NugetType.Libraries">
    </ui-nuget-deployment-settings>
</div>
